module.exports = __webpack_public_path__ + "static/media/search-white.dda53e09.svg";